export default __webpack_public_path__ + "static/media/navigation_outline_blue.8aa9f00c.svg";